﻿import threeDigits from './threeDigits';

export default function (value, sign = "₽") {
    if (value) {
        if (value / 1000000 >= 1)
            return `${threeDigits(value / 1000000, 2)} млн. ${sign}`;
        if (value / 1000 >= 1)
            return `${threeDigits(value / 1000)} тыс. ${sign}`;
        if (value / 1 >= 1)
            return `${threeDigits(value / 1)} ${sign}`;
    }
    else return 0;
}